import React from 'react'
import PropTypes from 'prop-types'
import CurrentHeadCountDetailReport from './CurrentHeadCountDetailReport'
import { range, find, get } from 'lodash'
import DataFilters from '../../DataFilters'
import { round } from '../../../../../helpers'
import {
	Paper,
} from '@material-ui/core'
import { useStyles } from '../styles'


export default function CurrentHeadCountDetail(props) {
	const classes = useStyles();
	const groups = ['E', 'M', 'P', 'S']
	const groupsNames = {
		'E': 'Executive (E)',
		'M': 'People Mgmt (M)',
		'P': 'Professional IC (P)',
		'S': 'Support (S)',
	}

	const categoryFilters = {
		'executive': true,
		'management': true,
		'professional': true,
		'support': true
	}

	const onApply = (filters) => {
		props.onApply(filters, 'WorkforceCurrentHeadCountDetails')
	}

	const levelsData = []
	const groupSummary = {}
	let currentTotalN = 0

	groups.forEach(g => {
		groupSummary[g] = {
			current: { totalN: 0, totalPercent: 0 },
		}
	})

	range(14).forEach(level => {
		const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
		const groupData = {}
		groups.forEach(g => {
			groupData[g] = {
				level: '',
				title: '',
				current: { n: '', percent: '' },
			}
		})

		levelData.forEach(ld => {
			const groupKey = ld.job_grade.slice(0, 1)
			const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })

			groupData[groupKey].level = ld.job_grade
			groupData[groupKey].title = ld.job_title

			if (dataInReport) {
				groupData[groupKey].current.n = get(dataInReport, 'total', 0)
				groupData[groupKey].current.percent = get(dataInReport, 'total', 0)
				groupSummary[groupKey].current.totalN = round(groupSummary[groupKey].current.totalN + groupData[groupKey].current.n)
			}
		})
		levelsData.push(groupData)
	})

	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				level[group].current.percent = round((level[group].current.n / groupSummary[group].current.totalN) * 100)
				groupSummary[group].current.totalPercent = round(groupSummary[group].current.totalPercent + level[group].current.percent)
				level[group].current.percent = level[group].current.percent.toFixed(1)
			}
		})
	})

	Object.keys(groupSummary).forEach(key => {
		currentTotalN += groupSummary[key].current.totalN
		groupSummary[key].current.totalPercent = round(groupSummary[key].current.totalPercent, 0)
	})

	const groupsForGraphs = []
	for (const categoryKey in categoryFilters) {
		if (get(categoryFilters, categoryKey, false)) {
			groupsForGraphs.push(categoryKey.substr(0, 1).toUpperCase())
		}
	}

	const graphsDataByGrades = {}
	levelsData.forEach(level => {
		for (const grade in level) {
			if (!graphsDataByGrades[grade]) {
				graphsDataByGrades[grade] = []
			}
			if (level[grade].level) {
				graphsDataByGrades[grade].push({ title: level[grade].level, count: level[grade].current.n !== '' ? level[grade].current.n : 0 })
			}
		}
	})

	return (
		<React.Fragment>
			<Paper className={classes.root}>
				<DataFilters
					fetchedFilterData={props.fetchedFilterData}
					filtersData={props.filtersData}
					onDataFilterSelect={props.onDataFilterSelect}
					componentName={'WorkforceCurrentHeadCountDetails'}
					reportFilters={props.reportFilters}
					onApply={onApply}
					resetFilter={props.resetFilter}
					reportFiltersType={props.reportFiltersType}
					reportDataChanged={props.reportDataChanged}
				/>
				<CurrentHeadCountDetailReport
					currentTotalN={currentTotalN}
					groups={groups}
					groupSummary={groupSummary}
					groupsNames={groupsNames}
					levelsData={levelsData}
					graphsDataByGrades={graphsDataByGrades}
				/>
			</Paper>
		</React.Fragment>
	)
}

CurrentHeadCountDetail.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.array.isRequired,
	onApply: PropTypes.func.isRequired,
}
